"use strict";

module.exports = {
  read: function memoryRead() {
    return {};
  },
  write: function memoryWrite() {
    return {};
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/lowdb/lib/storages/memory.js
// module id = 131
// module chunks = 0